import { render, staticRenderFns } from "./ProjectPlatformAdd.vue?vue&type=template&id=5f11bd0a&scoped=true"
import script from "./ProjectPlatformAdd.vue?vue&type=script&lang=js"
export * from "./ProjectPlatformAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f11bd0a",
  null
  
)

export default component.exports